/** @format */
"use client";
import { usePathname } from "next/navigation";
import NavBar from "@/component/NavBar/NavBar";
import "./globals.css";
import Footer from "@/component/Footer/Footer";

export default function RootLayout({ children }) {
  const pathname = usePathname();
  const hideHeaderFooter = pathname === "/book-appointment";

  return (
    <html lang="en">
      <head>
        <meta
          name="google-site-verification"
          content="NXI9wIJYCwp0qFUmBmjW96G_tkfSvTDQWULp8jqwOhM"
        />
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-1LEFNEVL6H"
        ></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-1LEFNEVL6H');
            `,
          }}
        />
        {/* <link
          href="https://fonts.cdnfonts.com/css/graphik-trial"
          rel="stylesheet"
        /> */}
        <link href="https://fonts.cdnfonts.com/css/graphik-trial" rel="stylesheet" />

      </head>
      <body style={{ fontFamily: "'Graphik Trial', sans-serif" }}>
        {!hideHeaderFooter && <NavBar />}
        {children}
        {!hideHeaderFooter && <Footer />}
      </body>
    </html>
  );
}
